import React from 'react';
import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';

const RadioWrapper = styled.label<{ checked: boolean; disabled: boolean | undefined }>`
  width: 155px;
  height: 50px;
  border: 1px solid ${COLORS.borderGrey};
  border-radius: 3px;
  display: flex;
  align-items: center;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  input {
    display: none;
  }
  label {
    color: ${(p) => (p.disabled ? COLORS.textLightGrey : COLORS.bodyColor)} !important;
    cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  }
  .radio-circle {
    margin: 0px 16px;
    height: 24px;
    width: 24px;
    transition: all 0.1s ease-in;
    transition-delay: 0.05s;
    border: 2px solid
      ${(p) => (p.checked ? COLORS.brandPrimary : p.disabled ? COLORS.textDarkGray : COLORS.black)};
    border-radius: 50%;
    position: relative;
    display: block;
    box-sizing: border-box;
    div {
      transition: all 0.1s ease-in;
      visibility: ${(p) => (p.checked ? 'visible' : 'hidden')};
      position: absolute;
      height: 100%;
      width: 100%;
      border-radius: 50%;
      border: 2px solid ${COLORS.white};
      background-color: ${COLORS.brandPrimary};
    }
  }
  @media only screen and (max-device-width: 320px) {
    width: 145px;
  }
`;

type RADIO_FIELD = {
  input?: {
    checked?: boolean;
    name?: string;
    value?: string;
  };
  meta?: {
    form?: string;
    initial?: string;
  };
  type?: string;
  label?: string;
  onClick?: any;
  disabled?: boolean;
};

const RadioField: React.FC<RADIO_FIELD> = (props: RADIO_FIELD) => {
  const { input, label, onClick, disabled } = props;

  return (
    <RadioWrapper
      checked={input?.checked || false}
      id={input?.value + '-field'}
      htmlFor={input?.value + '-id'}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="radio-circle">
        <div />
      </div>
      <label htmlFor={input?.value + '-id'}>{label}</label>
      <input type="radio" id={input?.value + '-id'} {...input} disabled={disabled} />
    </RadioWrapper>
  );
};

export default RadioField;
